const initState = localStorage.getItem('theme') || 'light';
const darkMode = (state = initState, action) => {
  switch (action.type) {
    case 'darkmode':
      return action.value;
    default:
      return state;
  }
};

export default darkMode;
